import React from "react";
import { toStringMessageDate } from "../vendor/DateUtil";

export const EndMedia = () => {
  const date = new Date();
  return <div>{toStringMessageDate(date)}</div>;
};
